import AutomationQuestion from './AutomationQuestion.component';

export default AutomationQuestion;